import { apiGateway } from './apiUsersRoutes';

export const apiAdminRoutes = {
  apiAdminPaymentsCalculate() {
    return `${apiGateway}/admin/accruals/calculate`;
  },
  apiFetchServerDateTime() {
    return `${apiGateway}/server/time`;
  },
  apiAdminCosts() {
    return `${apiGateway}/admin/costs`;
  },
  apiAdminYesterdayCost() {
    return `${apiGateway}/admin/cost`;
  },
  apiAdminNewbieCost() {
    return `${apiGateway}/admin/newbie/cost`;
  },
  apiAdminNewbieAdjust() {
    return `${apiGateway}/admin/newbie/adjust`;
  },
  apiAdminFetchUsers() {
    return `${apiGateway}/admin/users`;
  },
  apiAdminUserCost() {
    return `${apiGateway}/admin/user/cost`;
  },
  apiAdminUserAdjust() {
    return `${apiGateway}/admin/user/adjust`;
  },
  apiAdminUserVip() {
    return `${apiGateway}/admin/user/vip`;
  },
  apiAdminUserBan() {
    return `${apiGateway}/admin/user/ban`;
  },
  apiAdminUsersExport() {
    return `${apiGateway}/admin/users/export`;
  },
  apiAdminFetchPaymentHistory() {
    return `${apiGateway}/admin/payments`;
  },
  apiAdminPaymentHistoryExport() {
    return `${apiGateway}/admin/payments/export`;
  },
  apiAdminFetchDeviceGroups() {
    return `${apiGateway}/admin/device/group`;
  },
  apiAdminDeviceGroupAdjust() {
    return `${apiGateway}/admin/device/group/adjust`;
  },
  apiAdminDeviceGroupsExport() {
    return `${apiGateway}/admin/device/group/export`;
  },
  apiAdminFetchEquipmentGroups() {
    return `${apiGateway}/admin/equipment`;
  },
  apiAdminEquipmentGroupsExport() {
    return `${apiGateway}/admin/equipment/export`;
  },
  apiAdminEquipmentGroupDeviceGroupName() {
    return `${apiGateway}/admin/equipment/change`;
  },
  apiAdminPoolConfigs() {
    return `${apiGateway}/admin/pool`;
  },
  apiAdminGroupPoolConfigs() {
    return `${apiGateway}/admin/device/group/pools`;
  },
  apiAdminAllPoolConfigs() {
    return `${apiGateway}/admin/pool/all`;
  },
  apiAdminImpersonateUser(userId: string) {
    return `${apiGateway}/admin/impersonate/${userId}`;
  },
  apiAdminCalculatePayments() {
    return `${apiGateway}/admin/payments/calculate`;
  },
  apiAdminUpdatePayment() {
    return `${apiGateway}/admin/payment/update`;
  }
};
